<template>
    <div>
        <app-page-top-section :title="$t('checking')">
            <app-default-button
                :title="$fieldTitle('bulk', 'checking', true)"
                btnClass="btn btn-warning mr-2"
                v-if="$can('create_hotel_checking')"
                @click="openBuckModal()"
            />
            <app-default-button
                :title="$fieldTitle('add', 'checking', true)"
                v-if="$can('create_hotel_checking')"
                @click="openModal()"
            />
        </app-page-top-section>

        <app-table
            id="checking-table"
            :options="options"
            :card-view="true"
            @action="triggerActions"
            @getFilteredValues="getFilterValues"
        />

        <app-hotel-grid-checking-create
            v-if="isModalActive"
            v-model="isModalActive"
            :selected-url="checkingUrl"
            :hotel_id="hotel.id"
            :room_id="room_id"
            @close="isModalActive = false"
        />

        <app-hotel-grid-checking-bulk-create
            v-if="isBuckModalActive"
            v-model="isBuckModalActive"
            :selected-url="checkingUrl"
            :hotel_id="hotel.id"
            :rooms="checked"
            @close="isBuckModalActive = false"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('checking-table')"
            @cancelled="cancelled"
        />
    </div>
</template>

<script>
import FormHelperMixins from "../../../../../../common/Mixin/Global/FormHelperMixins";
import {TENANT_BASE_URL} from "../../../../../../common/Config/UrlHelper";
import HotelGridCheckingMixins from "../../../../Mixins/HotelGridCheckingMixins";
import {axiosGet} from "../../../../../../common/Helper/AxiosHelper";

export default {
    name  : "HotelChecking",
    mixins: [FormHelperMixins, HotelGridCheckingMixins],
    props : {
        hotel: null,
    },
    data() {
        return {
            isModalActive    : false,
            isBuckModalActive: false,
            room_id          : null,
            checkingUrl        : '',
            checked          : [],
        }
    },
    mounted() {
        this.$hub.$on('checked-values-rooms', (checked) => {
            this.checked = checked
        })
        axiosGet(`${TENANT_BASE_URL}selectable/hotel/room?hotel_id=${this.hotel.id}&group=floor&format=floor`)
            .then(({data}) => this.options.filters[1].option = data)
            .catch(error => this.$toastr.e(error.response.data.message))
        axiosGet(`${TENANT_BASE_URL}selectable/hotel/cleaning`)
            .then(({data}) => this.options.filters[3].option = data)
            .catch(error => this.$toastr.e(error.response.data.message))
        axiosGet(`${TENANT_BASE_URL}selectable/hotel/staying`)
            .then(({data}) => this.options.filters[4].option = data)
            .catch(error => this.$toastr.e(error.response.data.message))
    },
    methods: {
        triggerActions(row, action, active) {
            if (action.title === this.$t('edit')) {
                this.checkingUrl   = `${TENANT_BASE_URL}app/hotel/checking/${row.checking.id}`;
                this.isModalActive = true;
            } else if (action.title === this.$t('create')) {
                this.room_id       = row.id
                this.isModalActive = true;
                this.checkingUrl   = ''
            } else {
                this.getAction(row.checking, action, active)
            }
        },
        openModal() {
            this.room_id       = null
            this.isModalActive = true;
            this.checkingUrl   = ''
        },
        openBuckModal() {
            this.isBuckModalActive = true;
            this.checkingUrl         = ''
        },
        getRoom(floor) {
            axiosGet(`${TENANT_BASE_URL}selectable/hotel/room?hotel_id=${this.hotel.id}&floor=${floor}&format=number`)
                .then(({data}) => this.options.filters[2].option = data)
                .catch(error => this.$toastr.e(error.response.data.message))
        },
        getFilterValues(filters) {
            if (filters.floor) {
                this.getRoom(filters.floor)
            }
        },
    },
}
</script>